export const BenefitsSection = () => {
  const benefits = [
    {
      title: "5x",
      description: "Faster Data Analysis",
      color: "from-blue-400 to-blue-600"
    },
    {
      title: "60%",
      description: "Cost Reduction",
      color: "from-blue-500 to-blue-700"
    },
    {
      title: "98%",
      description: "Accuracy Improvement",
      color: "from-blue-600 to-blue-800"
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            The Impact of Analytics
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            See how our analytics solutions drive real business results
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className={`p-8 rounded-lg bg-gradient-to-br ${benefit.color} text-white text-center transform hover:scale-105 transition-transform duration-300`}
            >
              <div className="text-4xl font-bold mb-2">{benefit.title}</div>
              <div className="text-sm opacity-90">{benefit.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};